import React from 'react';

import { trackClientError } from './client';

interface State {
  failed: boolean;
}

// The root boundary: a render error anywhere would otherwise blank the whole app silently.
export default class TelemetryErrorBoundary extends React.Component<
  React.PropsWithChildren,
  State
> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    trackClientError(error, {
      source: 'render',
      componentStack: info.componentStack || undefined,
    });
  }

  render(): React.ReactNode {
    const { failed } = this.state;
    const { children } = this.props;
    if (!failed) return children;
    return (
      <div role="alert" className="app-crash">
        <h1>Something went wrong</h1>
        <p>The error has been recorded. Reload the page to carry on.</p>
        <button
          type="button"
          className="btn-app btn-app--primary"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    );
  }
}
